const styles = theme => ({
  root: {
    marginBottom: theme.spacing(4),
  },
  container: {
    display: 'flex',
    padding: theme.spacing(3, 2),
    alignItems: 'center',
    overflowX: 'auto',
  },
  item: {
    flex: '1',
    marginRight: theme.spacing(2),
  },
  itemExtended: {
    flex: '2',
    marginRight: theme.spacing(2),
  },
  itemAvatar: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    marginRight: theme.spacing(2),
  },
  itemTitle: {
    ...theme.typography.subtitle2,
    fontWeight: theme.typography.fontWeightBold,
    whiteSpace: 'nowrap',
  },
  itemDescription: {
    whiteSpace: 'nowrap',
  },
  buttonDelete: {
    marginLeft: theme.spacing(2),
    fontSize: theme.spacing(3),
  },
})

export default styles
